
import { MutationType } from '@domain/inventory/enums/MutationType.enum';
import { RuleField } from '@domain/inventory/enums/RuleField.enum';
import { RuleOperator } from '@domain/inventory/enums/RuleOperator.enum';
import { WarehouseConnectionType } from '@domain/inventory/enums/WarehouseConnectionType.enum';
import { WarehouseConnection } from '@domain/inventory/models/WarehouseConnection';
import { WarehouseConnectionRule } from '@domain/inventory/models/WarehouseConnectionRule';
import { WarehouseConnectionDto } from '../dto/WarehouseConnectionDto';
import { WarehouseConnectionRuleDto } from '../dto/WarehouseConnectionRuleDto';

export class WarehouseConnectionMapper {
    static toModel(dto: WarehouseConnectionDto): WarehouseConnection {
        return {
            id: dto.id,
            mutationType: dto.mutationType as MutationType,
            sourceType: dto.sourceType as WarehouseConnectionType,
            rules: dto.rules.map(rule => ({
                operator: rule.operator as RuleOperator,
                field: rule.field as RuleField,
                value: rule.value
            })),
            activeFrom: dto.activeFrom ? new Date(dto.activeFrom) : undefined,
            activeUntil: dto.activeUntil ? new Date(dto.activeUntil) : undefined,
        };
    }

    static ruleToDto(model: WarehouseConnectionRule): WarehouseConnectionRuleDto {
        return {
            operator: model.operator,
            field: model.field,
            value: model.value
        };
    }
} 